// Recognise emoji-only content without treating digits, punctuation, isolated
// modifiers or joiners as emoji. Composite emoji stay intact (flags, keycaps,
// skin tones, ZWJ families/professions and subdivision flag tag sequences).
// This is presentation detection, not validation of the Unicode RGI catalogue.
const pictograph = '(?:(?![©®™])\\p{Extended_Pictographic}|[©®™]\\uFE0F)(?:\\uFE0F)?(?:\\p{Emoji_Modifier})?';
const emoji = `(?:[0-9#*]\\uFE0F?\\u20E3|\\p{Regional_Indicator}{2}|\\u{1F3F4}[\\u{E0061}-\\u{E007A}]{2,}\\u{E007F}|${pictograph}(?:\\u200D${pictograph})*)`;
const emojiOnly = new RegExp(`^(?:\\s*${emoji})+\\s*$`, 'u');

export function isEmojiOnlyMessage(content: string): boolean {
  return emojiOnly.test(content);
}
